import { render } from "./AppInputPassword.vue?vue&type=template&id=0e7e5eca&ts=true"
import script from "./AppInputPassword.vue?vue&type=script&lang=ts"
export * from "./AppInputPassword.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/wVusKqw4/1/kenniss/platform/educator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__